import React, { useEffect, useState } from "react";
import { Table, Button, Modal, Input, Select, Form, message } from "antd";
import dataService from "../networks/api/service/dataService";
import DynamicExcelUpload from "../components/DynamicExcelUpload";
import * as XLSX from "xlsx";
import { DownloadOutlined } from "@ant-design/icons";
import CustomTable from "../components/TableComponent/CustomTable";
import UploadButton from "../components/TableComponent/ButtonComponent/UploadButton";
import DownloadButton from "../components/TableComponent/ButtonComponent/DownloadButton";
import PrimaryButton from "../components/TableComponent/ButtonComponent/Buttons";
const BoothList = () => {
  const [data, setData] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [currentRecord, setCurrentRecord] = useState(null);
  const [form] = Form.useForm();
  const [assemblyOptions, setassemblyOptions] = useState([]);
  const [adminOptions, setadminOptions] = useState([]);
  const [panchayatOptions, setpanchayatOptions] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 5,
    total: 0,
  });
  // Columns for the table
  const columns = [
    { title: "Booth Name", dataIndex: "boothName", key: "boothName" },
    { title: "Booth Number", dataIndex: "boothNumber", key: "boothNumber" },
    {
      title: "Total Population",
      dataIndex: "totalPopulation",
      key: "totalPopulation",
    },
    {
      title: "Total Male Voters",
      dataIndex: "totalMaleVoter",
      key: "totalMaleVoter",
    },
    {
      title: "Total Female Voters",
      dataIndex: "totalFemaleVoter",
      key: "totalFemaleVoter",
    },
    {
      title: "Admin assigned",
      dataIndex: "isAdminAssigned",
      key: "isAdminAssigned",
      render: (isAdminAssigned) => (isAdminAssigned ? "Yes" : "No"),
    },
    {
      title: "Actions",
      key: "actions",
      render: (record) => (
        <Button type="link" onClick={() => handleEdit(record)}>
          Edit
        </Button>
      ),
    },
  ];

  // Show modal for adding a new booth
  const showModal = () => {
    setIsEditing(false);
    setIsModalVisible(true);
    form.resetFields();
  };

  const getExcelData = async (formData) => {
    console.log(formData, "getExcelData");
    try {
      const res = await dataService.uploadBulkBooth(formData);
      if (res.code === 200) {
        getBoothDetails();
      }
    } catch (e) {}
  };

  const downloadSampleFile = () => {
    const worksheet = XLSX.utils.json_to_sheet([
      {
        "Sl NO": "",
        CONSTITUENCY: "",
        ASSEMBLY: "",
        PANCHAYAT: "",
        "BOOTH NO": "",
      },
    ]);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Booth_Sample");
    XLSX.writeFile(workbook, "Booth_Sample.xlsx");
  };

  // Show modal for editing an existing booth
  const handleEdit = (record) => {
    console.log(record);
    getPanchayatFromId(record.assembly);

    setIsEditing(true);
    setIsModalVisible(true);
    setCurrentRecord(record);
    form.setFieldsValue(record);
  };

  // Save booth (create or update based on editing state)
  const handleOk = async () => {
    try {
      const values = await form.validateFields();
      const payload = {
        boothName: values.boothName,
        boothNumber: values.boothNumber,
        totalPopulation: values.totalPopulation,
        totalMaleVoter: values.totalMaleVoter,
        totalFemaleVoter: values.totalFemaleVoter,
        adminId: values.adminId,
        panchayat: values.panchayat,
        assembly: values.assembly,
      };

      if (isEditing && currentRecord) {
        // Update existing booth
        await dataService.editBooth(currentRecord._id, payload);
        message.success("Booth updated successfully");
      } else {
        // Create new booth
        await dataService.addBooth(payload);
        message.success("Booth added successfully");
      }

      form.resetFields();
      setIsModalVisible(false);
      getBoothDetails();
    } catch (e) {
      message.error("Failed to save booth");
      console.error("Error:", e);
    }
  };

  // Handle modal cancel
  const handleCancel = () => {
    form.resetFields();
    setIsModalVisible(false);
    setCurrentRecord(null);
    setpanchayatOptions([]);
  };

  // Fetch options and booth data
  useEffect(() => {
    getBoothDetails();
    // getPanchayat();
    getAssembly();
    getAdmin();
  }, []);

  const getBoothDetails = async () => {
    try {
      const res = await dataService.getAllBoothDetails();
      setData(res.data);
      setFilteredData(res.data);
    } catch (e) {}
  };

  const handleTableChange = (pagination) => {
    setPagination(pagination);
  };

  // const getPanchayat = async () => {
  //   try {
  //     const res = await dataService.getAdminPanchayat();
  //     if (res.code === 200) {
  //       setpanchayatOptions(res.data);
  //     }
  //   } catch (e) {}
  // };

  const getAssembly = async () => {
    try {
      const res = await dataService.getAssemblyForPanchayat();
      if (res.code === 200) {
        setassemblyOptions(res.data);
      }
    } catch (e) {}
  };

  const getAdmin = async () => {
    try {
      const res = await dataService.getAdminForPanchayat("BOOTH");
      if (res.code === 200) {
        setadminOptions(res.data);
      }
    } catch (e) {}
  };

  const handleSearch = (e) => {
    const value = e.target.value.toLowerCase();
    const filtered = data.filter((item) =>
      item?.boothName?.toLowerCase()?.includes(value)
    );
    setFilteredData(filtered);
  };

  const getPanchayatFromId = async (value) => {
    const data = { assembly: value };
    try {
      const res = await dataService.getPanchayatFromAssembly(data);
      if (res.code === 200) {
        setpanchayatOptions(res.data);
      }
    } catch (e) {
      console.error(e);
    }
  };

  const OnAssemblySelect = async (value) => {
    console.log(value, "vaues", typeof value);

    getPanchayatFromId(value);
  };

  return (
    <div>
      <h2>Booth List</h2>

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          // marginBottom: 20,
        }}
      >
        <Button
          type="primary"
          onClick={showModal}
          style={{ marginBottom: 20 }}
        >
          Add Booth
        </Button>

        <Input.Search
          placeholder="Search by Booth Name"
          onChange={handleSearch}
          style={{ width: 200 }}
        />
      </div>
      {/* Table to show Booth List */}
      <CustomTable
        dataSource={filteredData}
        columns={columns}
        rowKey={(record) => record._id}
        bordered
        onChange={handleTableChange}
        customPagination={{
          current: pagination.current,
          pageSize: pagination.pageSize,
          total: pagination.total,
          showSizeChanger: true,
          pageSizeOptions: ["5", "10", "20"],
        }}
        size="middle"
        style={{
          boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
          borderRadius: "8px",
          backgroundColor: "#fff",
          width: "100%",
          overflowX: "auto",
        }}
        scroll={{ x: 800 }}
      />

      <div style={{ marginTop: 20 }}>
        <h3>Bulk Upload</h3>
        <div style={{ display: "flex", gap: 10, marginBottom: 20 }}>
          <DownloadButton onClick={downloadSampleFile}>
            Download Sample File
          </DownloadButton>
        </div>
        <DynamicExcelUpload getExcelData={getExcelData} />
      </div>

      {/* Modal for adding/editing Booth */}
      <Modal
        title={isEditing ? "Edit Booth" : "Add Booth"}
        visible={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        okText="Save"
        cancelText="Cancel"
      >
        <Form form={form} layout="vertical">
          <Form.Item
            label="Booth Name"
            name="boothName"
            rules={[{ required: true, message: "Please enter Booth Name" },
              { pattern: /^[A-Za-z\s]+$/, message: "Only letters and spaces are allowed" }
            ]}
          >
            <Input placeholder="Enter Booth Name" />
          </Form.Item>

          <Form.Item
            label="Booth Number"
            name="boothNumber"
            rules={[{ required: true, message: "Please enter Booth Number" },
              { pattern: /^[1-9][0-9]*$/, message: "Only positive numbers are allowed" }
            ]}
          >
            <Input placeholder="Enter Booth Number" />
          </Form.Item>

          <Form.Item
            label="Total Population"
            name="totalPopulation"
            rules={[
              { required: true, message: "Please enter Total Population" },
              { pattern: /^[1-9][0-9]*$/, message: "Only positive numbers are allowed" }
            ]}
          >
            <Input placeholder="Enter Total Population" />
          </Form.Item>

          <Form.Item
            label="Total Male Voters"
            name="totalMaleVoter"
            rules={[
              { required: true, message: "Please enter Total Male Voters" },
              { pattern: /^[1-9][0-9]*$/, message: "Only positive numbers are allowed" }
            ]}
          >
            <Input placeholder="Enter Total Male Voters" />
          </Form.Item>

          <Form.Item
            label="Total Female Voters"
            name="totalFemaleVoter"
            rules={[
              { required: true, message: "Please enter Total Female Voters" },
              { pattern: /^[1-9][0-9]*$/, message: "Only positive numbers are allowed" }
            ]}
          >
            <Input placeholder="Enter Total Female Voters" />
          </Form.Item>

          <Form.Item
            label="Admin"
            name="adminId"
            rules={[{ required: true, message: "Please select an Admin" }]}
          >
            <Select
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) => {
                const children = option?.children;
                return String(children)
                  .toLowerCase()
                  .includes(input.toLowerCase());
              }}
              style={{
                border: "1px solid grey",
                borderRadius: 5,
              }}
              placeholder="Select Admin"
            >
              {adminOptions.map((admin) => (
                <Select.Option key={admin._id} value={admin._id}>
                  {admin.name}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item label="Assembly" name="assembly">
            <Select
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) => {
                const children = option?.children;
                return String(children)
                  .toLowerCase()
                  .includes(input.toLowerCase());
              }}
              placeholder="Select Assembly"
              onChange={(value) => OnAssemblySelect(value)}
            >
              {assemblyOptions.map((assembly) => (
                <Select.Option key={assembly._id} value={assembly._id}>
                  {assembly.assemblyName}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item
            label="Panchayat"
            name="panchayat"
            rules={[{ required: true, message: "Please select a Panchayat" }]}
          >
            <Select
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) => {
                const children = option?.children;
                return String(children)
                  .toLowerCase()
                  .includes(input.toLowerCase());
              }}
              placeholder="Select Panchayat"
            >
              {panchayatOptions.map((panchayat) => (
                <Select.Option key={panchayat._id} value={panchayat._id}>
                  {panchayat.panchayatName}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default BoothList;
